import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { useSeoMeta } from '@/hooks/useSeoMeta';
import SectionRenderer from '@/components/sections/SectionRenderer';

export default function HomePage() {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/cms/pages/home')
      .then(r => setPage(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  useSeoMeta(page);

  if (loading) return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="animate-pulse text-muted-foreground text-sm">Loading...</div>
    </div>
  );

  return (
    <div data-testid="home-page">
      <SectionRenderer sections={page?.sections || []} />
    </div>
  );
}
